<div class="icon-container">
    <mat-icon  class="icon-style" [ngStyle]="{'color': iconColor, 'font-size':fontSize}">{{iconName}}</mat-icon>
</div>
